var map = {
	"./digital_twins.png": 10109,
	"./gamification.png": 40506,
	"./loyalty_coins.png": 35908,
	"./marketplace.png": 71468,
	"./membership.png": 73609,
	"./shared_ownership.png": 22260,
	"./smart_tickets.png": 90268,
	"./social.png": 20176
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89465;